import { render, staticRenderFns } from "./StockImport.vue?vue&type=template&id=3051e234&scoped=true&"
import script from "./StockImport.vue?vue&type=script&lang=js&"
export * from "./StockImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3051e234",
  null
  
)

export default component.exports